<template>
  <Layout>
    <Loader :loading="loading" no-axios>
      <div v-if="(model || {}).id">
        <div class="row g-16px">
          <div class="col-md-12">
            <div class="model-title d-flex align-items-center gap-4">
              <a @click="$router.back()" role="button">
                <i class="mdi mdi-arrow-left"></i>
              </a>
              {{ lodash.startCase($t("trips.singular")) }}
            </div>
          </div>
          <div v-if="!denyDelete" class="col-md-12">
            <div class="text-end">
              <b-button class="btn btn-danger" @click="handleDelete">
                <b>{{ $t('Delete') }}</b>
              </b-button>
            </div>
          </div>
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-8">
                    <div class="">
                      <div class="row g-0 description-detail" v-if="model.ticket">
                        <div class="col-md-3 label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.ticket_id`)) }}
                        </div>
                        <div class="col-md-9 value text-sm">
                          <router-link :to="`/tickets/${model.ticket.id}`">{{
                              `${model.ticket.id} (${this.$t(`tickets.customer_types.${model.ticket.customer_type}`)})`
                            }}
                          </router-link>
                        </div>
                      </div>
                      <div class="row g-0 description-detail" v-else>
                        <div class="col-md-3 label font-size-500">
                          {{ lodash.startCase($t(`purchase_plans.sales_plan_id`)) }}
                        </div>
                        <div class="col-md-9 value text-sm">
                          <template v-if="salesPlans.length">
                            <span v-for="(plan, index) in salesPlans" v-bind:key="plan.id">
                              <router-link class="sales-plan-link" :to="`/sales_plans/${plan.id}`">
                                {{ salesPlanDisplayName(plan) }}
                              </router-link>
                              <span v-if="index !== salesPlans.length - 1">, </span>
                            </span>
                          </template>
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="row g-0 description-detail">
                        <div class="col-md-3 label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.purchase_order_id`)) }}
                        </div>
                        <div class="col-md-9 value text-sm">
                          <div v-for="(item, index) in model.purchase_orders" v-bind:key="item.id">
                            <router-link :to="`/purchase_orders/${item.id}`">{{ `${item.id} (${item.customer.name} - ${$moment.utc(item.ordered_at).local().format("DD MMM YYYY")})` }}</router-link>
                            <span v-if="index !== (model.purchase_orders || []).length - 1">, </span>
                          </div>
                        </div>
                      </div>
                      <div class="row g-0 description-detail">
                        <div class="col-md-3 label font-size-500">
                          {{ lodash.startCase($t(`trips.sale_note_id`)) }}
                        </div>
                        <div class="col-md-9 value text-sm">
                          <router-link v-if="model.sale_order" :to="`/sale_notes/${model.sale_order.id}`">
                            {{ `${model.type_name} - ${model.sale_order.id}` }}
                          </router-link>
                          <router-link v-else :to="{
                            name: 'unload.create',
                            params: {
                              ticketable: model.ticket ? { ticket_id: model.ticket.id } : undefined,
                              trip_id: model.id,
                            }
                          }" class="text-red-500 bg-red-100 px-8px py-1px badge">
                            ID Belum Tersedia
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-md-4">
                    <div class="">
                      <div class="description-detail" v-if="model.invoice_number">
                        <div class="label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.invoice_number`)) }}
                        </div>
                        <div class="text-neutral-600">
                          {{ model.invoice_number || '-' }}
                        </div>
                      </div>
                      <div class="description-detail">
                        <div class="label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.tripped_at`)) }}
                        </div>
                        <div class="text-neutral-600">
                          {{ model.tripped_at ? $moment.utc(model.tripped_at).local().format('DD MMMM YYYY') : '-' }}
                        </div>
                      </div>
                      <div class="description-detail">
                        <div class="label font-size-500">
                          {{ lodash.startCase($t('products.singular')) }}
                        </div>
                        <div class="text-neutral-600">
                          {{ productName }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="">
                      <div class="row g-0 description-detail" v-if="model.vehicle">
                        <div class="label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.vehicle`)) }}
                        </div>
                        <div class="text-neutral-600">
                          <span v-if="model.vehicle">
                            {{ lodash.upperFirst(vehicleName)}} - {{model.vehicle.license_plate}}
                          </span>
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="row g-0 description-detail" v-if="model.driver">
                        <div class="label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.driver`)) }}
                        </div>
                        <div class="text-neutral-600">
                          <span v-if="model.driver">
                            {{ lodash.upperFirst(model.driver.name)}} - {{model.driver.phone_number}}
                          </span>
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="row g-0 description-detail" v-if="model.type !== 'hybrid'">
                        <div class="label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.to_processing`)) }}
                        </div>
                        <div class="text-neutral-600">
                          {{ this.model.customer && this.model.type !== 'hybrid' ? `${this.model.customer.name} (${this.model.customer.code})` : '-' }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div>
                      <div class="row g-0 description-detail">
                        <div class="col-md-12 font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.attachment`)) }}
                        </div>
                        <div class="col-md-12 value">
                          <attachment
                            :files="model.files"
                            v-if="model.files.length"
                          ></attachment>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="card">
              <div class="card-body d-flex flex-column gap-16px">
                <div class="d-flex align-items-center">
                  <div class="section-title flex-grow-1">
                    ITEM NOTA ARMADA (PI)
                  </div>
                  <a :href="model.invoice_export_url" target="_blank" v-if="!denyExport">
                    <b-button variant="success">
                      Unduh Nota Beli
                    </b-button>
                  </a>
                </div>
                <trip-item-table
                  :items="model.trip_items"
                  :product-type="model.type"
                ></trip-item-table>
                <hr>
                <div class="d-flex align-items-center">
                  <div class="section-title flex-grow-1">
                    BIAYA OPERASIONAL
                  </div>
                  <a :href="model.trip_operations_export_url" target="_blank" v-if="!denyExport">
                    <b-button variant="success">
                      Unduh BOP
                    </b-button>
                  </a>
                </div>
                <trip-operation-table
                    v-if="model.trip_operations.length > 0"
                    :items="model.trip_operations"
                ></trip-operation-table>
                <div v-else>-</div>
                <hr>
                <div class="">{{ lodash.startCase($t(`${this.resourceRoute}.description`)) }}</div>
                <div class="">
                  <span v-html="this.model.description || '-'"></span>
                </div>
                <div class="caption-font-md text-neutral-300">Dibuat oleh: {{model.creator.name}} - {{$moment.utc(model.created_at).local().format('DD MMMM YYYY')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </Layout>
</template>

<script>
import ModelShow from '../models/show';
import Row from '@/components/models/show/custom-row';
import Loader from "@/components/widgets/loader.vue";
import TripItemTable from "@/router/views/trips/components/trip-item-table.vue";
import TripOperationTable from "@/router/views/trips/components/trip-operation-table.vue";
import Attachment from "@/router/views/trips/components/attachment.vue";
import Swal from "sweetalert2";
import { salesPlanDisplayName } from "@/helpers/ui/salesPlanLabels";

export default {
  components: {TripOperationTable, TripItemTable, Loader, Attachment},
  extends: ModelShow,
  page: {
    title: "Detail Trips",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('trips.singular')) }},
    resourceRoute: {default: 'trips'},
    modelVariable: {default: 'trip'},
    denyEdit: {type: Boolean, default: true},
    denyDelete: {type: Boolean, default: true},
    denyExport: {type: Boolean, default() { return !this.$auth.hasPermissionTo('trips.export') }},
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || 'model']: [
            {
              key: 'key',
              label: this.$t('models.key'),
              component: Row
            }
          ]
        };
      }
    },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('trips.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  watch: {
    model: {
      deep: true,
      handler: function (val, oldVal) {
        if (!this.lodash.isEqual(val, oldVal)) {
          let modelPolicy = this.modelPolicy(val)
          this.denyEdit = modelPolicy._denyEdit
          this.denyDelete = modelPolicy._denyDelete
        }
      }
    }
  },
  computed: {
    isCreator() {
      return this.model.creator.email === this.$auth.user().email
    },
    productName() {
      return [...new Set(this.model.trip_items.map(({purchase_order}) => purchase_order.product?.name).sort())].join(',')
    },
    purchasePlans() {
      let purchasePlans = []
      let purchasePlanIds = []
      ;(this.model.purchase_orders || []).forEach(({purchase_plan}) => {
        if (purchase_plan && !purchasePlanIds.includes(purchase_plan.id)) {
          purchasePlanIds = [...purchasePlanIds, purchase_plan.id]
          purchasePlans = [...purchasePlans, purchase_plan]
        }
      })
      return purchasePlans
    },
    salesPlans() {
      let salesPlans = []
      let salesPlanIds = []
      this.purchasePlans.forEach(({sales_plan}) => {
        if (sales_plan && !salesPlanIds.includes(sales_plan.id)) {
          salesPlanIds = [...salesPlanIds, sales_plan.id]
          salesPlans = [...salesPlans, sales_plan]
        }
      })
      return salesPlans
    },
    exportInvoiceUrl(){
      return `${process.env.VUE_APP_API_BASE_URL}/trips/${this.model.id}/invoice_export`
    },
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t('trips.plural')),
          href: "/trips",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/trips/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      let vm = this
      return this.lodash.isEmpty(this.model) ? [] : [
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.ticket_id`)),
          item: this.model.trip_items[0].purchase_order.ticket,
          value: {
            props: { item: { type: Object, default: () => {}}},
            template: '<router-link :to="`/tickets/${item.id}`">{{ `${item.id} (${this.$t(`tickets.customer_types.${item.customer_type}`)})` }}</router-link>'
          },
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
          // to: `/tickets/${this.model.trip_items[0].purchase_order.ticket.id}`,
          // value: `${this.model.trip_items[0].purchase_order.ticket.id} (${this.$t(`customers.types.${this.model.trip_items[0].purchase_order.ticket.customer_type}`)})`,

        },
        {
          key: this.lodash.startCase(this.$t(`trips.purchase_order_id`)),
          item: this.model,
          value: {
            props: { item: { type: Object, default: () => [] }},
            // template: '<div>{{$props}}</div>'
            template: '<div><template v-for="(item, index) in item.purchase_orders"><router-link :to="`/purchase_orders/${item.id}`">{{ `${item.id} (${item.customer.name} - ${$moment.utc(item.ordered_at).local().format("DD MMM YYYY")})` }}</router-link><span v-if="index !== (item || []).length - 1">, </span></template></div>'
          },
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
          // values: [...this.model.purchase_orders, ...this.model.purchase_orders].map((item) => {
          //   return {
          //     to: `/purchase_orders/${item.id}`,
          //     value: `${item.id} (${item.customer.name} - ${this.$moment.utc(item.ordered_at).local().format("DD MM YYY")})`
          //   }
          // })
          // to: `/purchase_orders/${this.model.purchase_orders[0].id}`,
          // value: `${this.model.purchase_orders[0].id} (${this.model.purchase_orders[0].customer.name} - ${this.$moment.utc(this.model.purchase_orders[0].ordered_at).local().format("DD MM YYY")})`,
        },
        {
          key: this.lodash.startCase(this.$t(`sale_notes.shows.sales_id`)),
          item: this.model.sale_order,
          value: {
            props: {
              item: {
                type: Object, default: () => {
                }
              }
            },
            computed: {
              isItemEmpty() {
                return this.lodash.isEmpty(this.item)
              }
            },
            template: '<template v-if="!isItemEmpty">' +
                '<router-link :to="`/sale_notes/${item.id}`">{{ `${item.id}` }}</router-link>' +
                '</template>' +
                '<template v-else>-</template>'
          },
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t('products.singular')),
          value: [...new Set(this.model.trip_items.map(tripItem => tripItem.purchase_order.product.name))].join(', '),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.invoice_number`)),
          value: this.model.invoice_number || '-',
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.tripped_at`)),
          value: vm.model.tripped_at ? vm.$moment.utc(vm.model.tripped_at).local().format('DD MMMM YYYY') : '-',
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.vehicle_id`)),
          item: this.model?.vehicle,
          value: {
            props: {item: { type: Object, default() { return [] }}},
            computed: {
              customLabel () {
                return `${this.lodash.upperFirst(this.vehicleName)} - ${this.item?.license_plate}`
              },
              vehicleName () {
                let label = this.item?.name

                if (this.item?.type === 'heavy') label = this.$t('vehicles.truck')
                else if (this.item?.type === 'medium') label = this.$t('vehicles.crank_truck')
                else if (this.item?.type === 'light') label = this.$t('vehicles.pickup')

                return label
              },
            },
            template: `<span v-html="customLabel"></span>`,
          },
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.driver`)),
          value: vm.model.driver ? `${vm.model.driver.name} - ${vm.model.driver.phone_number}`:'-',
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.to_processing`)),
          value: vm.model.customer && vm.model.type !== 'hybrid' ? `${vm.model.customer.name} (${vm.model.customer.code})` : '-',
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.$t(`${this.resourceRoute}.file`),
          item: this.model.files,
          value: {
            props: { item: { type: Array, default() { return [] }} },
            template:
                `<div class="col-md-6"><PreviewImagePdf  :preview="(item[0] || {}).url" :format="(item[0] || {}).extension"/></div>`
          },
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.trip_item`)) + ' (PO)',
          item: this.model.trip_items,
          value: {
            props: {
              item: {
                type: Array, default() {
                  return []
                }
              }
            },
            computed: {
              fields() {
                return [
                  {key: 'index', label: 'No', sortable: false, style: {width: '1%'}},
                  {
                    key: 'purchase_order',
                    label: `${this.lodash.startCase(this.$t('trip_items.purchase_order_id'))}`,
                    tdClass: 'text-start',
                    formatter: (value) => `${value.id} (${value.customer.name} ${value.ordered_at ? (' - ' + vm.$moment.utc(value.ordered_at).local().format('DD MMM YYYY')) : ''})`
                  },
                  {
                    key: 'purchase_item.quality',
                    label: `${this.lodash.startCase(this.$t('trip_items.quality'))}`,
                    formatter: (value) => value ? this.$t(`qualities.${value}`) : '-'
                  },
                  {
                    key: 'quantity',
                    label: `${this.lodash.startCase(this.$t('trip_items.quantity'))} (${this.$t('kg')})`,
                    tdClass: 'text-end',
                    formatter: (value) => this.$numeral(value).format('0,0.[00]')
                  },
                  {
                    key: 'size',
                    label: `${this.lodash.startCase(this.$t('trip_items.size'))}`,
                    tdClass: 'text-end',
                    formatter: (value) => this.$numeral(value).format('0,0.[00]')
                  },
                  {
                    key: 'unit_price', label: this.lodash.startCase(this.$t('trip_items.unit_price')),
                    tdClass: 'text-end',
                    formatter: (value) => this.$numeral(value).format('$ 0,0.[00]')
                  },
                  { key: 'total_price', label: this.lodash.startCase(this.$t('trip_items.total_price')),
                    tdClass: 'text-end',
                    formatter: (value) => this.$numeral(value).format('$ 0,0.[00]')
                  },
                  { key: 'label', label: `${this.lodash.startCase(this.$t('trip_items.label'))}` },
                  { key: 'customer.name', label: `${this.lodash.startCase(this.$t('trip_items.farmer'))}` },
                ]
              }
            },
            template: '<b-table :fields="fields" :items="item">' +
                '<template #cell(index)="data">{{ data.index + 1 }}</template>' +
                '<template #cell()="data">{{ data.value ? data.value : "-" }}</template>' +
                '</b-table>'
          },
        },
        {
          key: 'Biaya Operasional',
          item: this.model.trip_operations,
          value: {
            props: { item: { type: Array, default () { return [] } } },
            computed: {
              fields () {
                return [
                  {key: 'index', label: 'No', sortable: false, style: {width: '1%'}},
                  {
                    key: 'alternative_name',
                    label: 'Nama',
                    tdClass: 'text-start',
                    formatter: (value) => this.lodash.upperFirst(value)
                  },
                  {
                    key: 'total', label: this.lodash.startCase(this.$t('trip_items.total_price')),
                    tdClass: 'text-end',
                    formatter: (value) => this.$numeral(value).format('$ 0,0.[00]')
                  },
                ]
              }
            },
            template: '<b-table :fields="fields" :items="item">' +
                '<template #cell(index)="data">{{ data.index + 1 }}</template>' +
                '<template #cell()="data">{{ data.value ? data.value : "-" }}</template>' +
                '</b-table>'
          },
        },
        {
          key: this.lodash.startCase(this.$t(`trips.total_quantity_overall`)),
          value: this.$numeral(this.model.trip_item_total_quantity).format('0,0.[00]') + ' kg',
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`trips.total_item_overall`)),
          value: this.$numeral(this.model.trip_item_total).format('$ 0,0.00'),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: 'PPh beli',
          value: this.$numeral(this.model.trip_items.reduce((carry, {total_price}) => carry + total_price, 0) * (0.25 / 100)).format('$ 0,0.00'),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`trips.description`)),
          item: this.model.description,
          value: {
            props: { item: {type: String, default: ''} },
            template: `<span v-html="item || '-'"></span>`
          },
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`CreatedBy`)),
          value: this.lodash.startCase(this.model.creator.name || '-'),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
          styles: { fontSize:'10px', opacity: '0.8' },
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.created_at`)),
          value: this.$moment.utc(this.model.created_at).local().format('DD MMMM YYYY'),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
          styles: { fontSize:'10px', opacity: '0.8' },
        },
      ]
    },
    pph22(){
      return this.$numeral(this.model.trip_items.reduce((carry, {total_price}) => carry + total_price, 0) * (0.25 / 100)).format('$ 0,0.00')
    },
    vehicleName () {
      let label = this.model?.vehicle?.name

      if (this.model?.vehicle?.type === 'heavy') label = this.$t('vehicles.truck')
      else if (this.model?.vehicle?.type === 'medium') label = this.$t('vehicles.crank_truck')
      else if (this.model?.vehicle?.type === 'light') label = this.$t('vehicles.pickup')

      return label;
    },
  },
  methods: {
    salesPlanDisplayName,
    exportInvoice() {
      this.loadingExport = true
      return this.$axios.get(`/trips/${this.model.id}/invoice_export`, {
        responseType: 'blob',
      })
          .then(res => {
            // create file link in browser's memory
            const href = URL.createObjectURL(res.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            const fileName = `Balancing Payment - ${this.$moment(this.model.paid_at).format('DD MMM YYYY')}.pdf`
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
            return res
          }).catch(() => {
            return Swal.fire({
              title: this.lodash.startCase(this.$t('failed')),
              text: this.lodash.upperFirst(this.$t('download_failed')),
              type: 'danger',
              confirmButtonClass: 'btn btn-danger btn-fill',
              buttonsStyling: false
            })
          }).finally((res) => {
            this.loadingExport = false
            return res
          })
    },
    getModelName() {
      return this.model['id'];
    },
    delete() {
      return this.$axios.delete(`/trips/${this.$route.params.key}`)
    },
    handleDelete() {
      this.deleteConfirmAlert().then(result => {
        if (result.value) {
          this.delete()
              .then(() => this.deleteSuccessAlert(this.getModelName()))
              .then(() => this.$router.push('/trips'))
              .catch((error) => this.failedAlert(error));
        }
      });
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/trips/${this.$route.params.key}`, {
        params: {
          with: [
            'creator',
            'driver',
            'files',
            'ticket',
            'trip_items.customer',
            'trip_items.purchase_item',
            'trip_items.purchase_order.customer',
            'trip_items.purchase_order.ticket',
            'trip_items.purchase_order.purchase_plan.product',
            'trip_items.purchase_order.purchase_plan.sales_plan',
            'trip_items.purchase_order.product',
            'trip_operations',
            'vehicle',
            'sale_order',
            'sale_orders',
            'customer',
          ].join(',')
        }
      }).then((response) => {
        const { data: { data } } = response;
        let purchaseOrders = []
        data.trip_items.forEach(tripItem => {
          let purchaseOrderIds = purchaseOrders.map(purchaseOrder => purchaseOrder.id)
          if (!purchaseOrderIds.includes(tripItem.purchase_order.id)) {
            purchaseOrders = [
              ...purchaseOrders,
              tripItem.purchase_order,
            ]
          }
        })
        this.model = {
          ...data,
          purchase_orders: purchaseOrders,
        }

        const modelPolicy = this.modelPolicy(this.model);
        this.denyEdit = modelPolicy._denyEdit;
        this.denyDelete = modelPolicy._denyDelete;

        return response;
      }).catch((error) => this.failedAlert(error)).finally(() => this.loading = false)
    },
    modelPolicy(model) {
      const hasSaleOrder = !!model?.sale_order || (model?.sale_orders || []).length > 0;
      const canEdit = this.$auth.hasPermissionTo('trips.edit');
      const canDelete = this.$auth.hasPermissionTo('trips.delete');
      const isSuperadmin = this.$auth.hasRole('superadmin');
      const isOwner = model?.creator?.email === this.$auth?.user()?.email || isSuperadmin;

      return {
        _denyShow: false,
        _denyEdit: !canEdit || hasSaleOrder || !isOwner,
        _denyDelete: !canDelete || hasSaleOrder || !isOwner,
      }
    },
  }
}
</script>


<style scoped lang="scss">
  @import "@/design/colors";
  .model-title {
    font-family: Lato;
    font-size: 16px;
    font-weight: 800;
    line-height: 20px;
    letter-spacing: 0.05em;
  }
  .section-title {
    font-family: Lato;
    font-size: 12px;
    font-weight: 800;
    line-height: 14px;
    letter-spacing: 0.05em;
    color: $neutral-300;
  }
  .description-detail {
    padding: 8px;
  }
  .sales-plan-link {
    display: inline-block;
    max-width: 100%;
    overflow-wrap: anywhere;
    white-space: normal;
  }
  .card {
    margin-bottom: 0;
  }
</style>
